import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lead-boost-pause',
  templateUrl: './lead-boost-pause.component.html',
  styleUrls: ['./lead-boost-pause.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadBoostPauseComponent {
  @Input() minutesRemaining: number;
}
